"use client";

import { useState } from "react";
import { MediaGallery } from "@/@types";
import ModalVideoMedia from "@/components/ui/Modals/ModalVideoMedia";
import Image from 'next/image';
import { getEmbedUrl } from "@/helpers/media/getEmbedUrl";

type Props = {
    folletoMedia: MediaGallery | null;
    videoMedia: MediaGallery | null;
};

export default function MediaTechnologicalSolution({ folletoMedia, videoMedia }: Props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [titleVideo, setTitleVideo] = useState<string | null>(null);

    const openModalWithVideo = (titleVideo:string, url: string) => {
        const embedUrl = getEmbedUrl(url);
        setVideoUrl(embedUrl);
        setIsModalOpen(true);
        setTitleVideo(titleVideo);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setVideoUrl(null);
        setTitleVideo(null);
    };

    return (
        <div className="border-t-2 border-b-2 border-matco bg-silver p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Columna de Documentos */}
                <div>
                    <h2 className="text-center text-gray02 font-roboto-condensed text-[21px] leading-[27.3px]">
                        DOCUMENTOS
                    </h2>
                    <ul className="mt-4">
                        {folletoMedia && folletoMedia.length > 0 ? (
                            folletoMedia.map((documento, index) => {
                                const urlOriginal = documento.mediaLocal || documento.media;
                                const path = urlOriginal.split('/uploads/')[1];
                                                            
                                return (
                                    
                                    <li key={index} className="py-2 border-t">
                                        <a href={`/api/pdf/${path}`} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between">
                                            <span className="text-base font-medium">{documento.title}</span>
                                            <div className="flex items-center gap-4">
                                                 <Image src="/download.svg" alt="Descargar" width={20} height={20} className='w-4 h-4' />
                                            </div>
                                        </a>
                                    </li>
                                )
                            }
                        )
                        ) : (
                            <li className="text-center text-base font-medium">No hay documentos disponibles</li>
                        )}
                    </ul>
                </div>

                {/* Columna de Videos */}
                <div>
                    <h2 className="text-center text-gray02 font-roboto-condensed text-[21px] leading-[27.3px]">
                        VIDEOS
                    </h2>
                    <ul className="mt-4">
                        {videoMedia && videoMedia.length > 0 ? (
                            videoMedia.map((video, index) => (
                                <li key={index} className="py-2 border-t">
                                    <button
                                        onClick={() => openModalWithVideo(video.title, video.mediaLocal || video.media)}
                                        className="flex items-center justify-between w-full text-left"
                                    >
                                        <span className="text-base font-medium">{video.title}</span>
                                        <div className="flex items-center gap-4">
                                            <Image src="/video.svg" alt="Descargar" width={20} height={20} className='w-4 h-4' />
                                        </div>
                                    </button>
                                </li>
                            ))
                        ) : (
                            <li className="text-center text-base font-medium">No videos available</li>
                        )}
                    </ul>
                </div>
            </div>

            {/* Modal para mostrar el video */}
            <ModalVideoMedia isOpen={isModalOpen} onClose={closeModal} titleVideo={titleVideo} videoUrl={videoUrl} />
        </div>
    );
}